import { StringConst } from '../../constants/const';
export class SaveAdviserProfilePhoto {
    cardCode: string;
    profilePicture: string;
    pictureFormat: string;

    constructor() {
        this.cardCode = StringConst.empty;
        this.profilePicture = StringConst.empty;
        this.pictureFormat = StringConst.empty;
    }
}
